const steps = [
    {
        n: "01",
        title: "Diskusi",
        desc: "Obrolan ringan via WhatsApp atau ketemu langsung. Kami petakan tujuan, target pelanggan, dan ekspektasi.",
    },
    {
        n: "02",
        title: "Desain",
        desc: "Mockup desain yang sesuai karakter bisnis anda — bukan template generik.",
    },
    {
        n: "03",
        title: "Develop",
        desc: "Pengerjaan dengan kode bersih, mobile-first, dan optimasi SEO dasar built-in.",
    },
    {
        n: "04",
        title: "Launch",
        desc: "Rilis ke domain anda, training singkat untuk admin panel, lanjut maintenance bulanan opsional.",
    },
];

export const Process = () => {
    return (
        <section
            id="proses"
            data-testid="process-section"
            className="bg-jws-secondary text-jws-bg py-20 md:py-32 relative overflow-hidden"
        >
            <div className="max-w-7xl mx-auto px-5 md:px-10 relative">
                <div className="grid grid-cols-12 gap-6 mb-16 md:mb-24">
                    <div className="col-span-12 md:col-span-7">
                        <div className="text-xs uppercase tracking-[0.3em] text-jws-bg/60 mb-4">
                            (03) Proses
                        </div>
                        <h2 className="font-display text-4xl md:text-6xl tracking-tight leading-[1]">
                            Empat langkah,
                            <br />
                            <span className="italic text-jws-ochre">
                                tanpa drama
                            </span>
                            .
                        </h2>
                    </div>
                    <div className="col-span-12 md:col-span-4 md:col-start-9 md:pt-6">
                        <p className="text-jws-bg/70 leading-relaxed">
                            Transparan dari awal sampai akhir. Anda tahu sedang
                            di tahap mana, kapan rilis, dan apa yang
                            diperlukan dari tim anda.
                        </p>
                    </div>
                </div>

                {/* Steps */}
                <div className="grid grid-cols-1 md:grid-cols-4 gap-px bg-jws-bg/15 border border-jws-bg/15 rounded-2xl overflow-hidden">
                    {steps.map((s, i) => (
                        <div
                            key={s.n}
                            data-testid={`process-step-${s.n}`}
                            className="bg-jws-secondary p-8 md:p-10 relative group hover:bg-[#234835] transition-colors"
                        >
                            <div className="text-jws-ochre font-display text-4xl md:text-6xl tracking-tight">
                                {s.n}
                            </div>
                            <h3 className="mt-6 md:mt-8 font-display text-2xl md:text-3xl tracking-tight">
                                {s.title}
                            </h3>
                            <p className="mt-3 text-jws-bg/75 leading-relaxed text-sm md:text-base">
                                {s.desc}
                            </p>
                            {i < steps.length - 1 && (
                                <div className="hidden md:block absolute top-12 right-0 translate-x-1/2 h-px w-8 bg-jws-ochre" />
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};
